import { TableCell, TableRow } from "@mui/material";
import { getStateLabel } from "../../../utils/helpers/getStateLabel";
import ArrowNextTableIcon from "../../../assets/icons/svg/ArrowNextTableIconSVG";
import { getFallbackMakeLogoImage } from "../../../utils/carLogo/getFallbackMakeLogoImage";

const AllOffersTableRow = ({ carOffers, onSelect }) => {
  const stateLabel = getStateLabel(carOffers?.status);
  const makeName = carOffers.PartRequest.Make.name;
  const generationName = carOffers.PartRequest.Generation.name;
  const logo = getFallbackMakeLogoImage(makeName);

  return (
    <TableRow hover onClick={onSelect} sx={{ cursor: "pointer" }}>
      <TableCell sx={styles.logoCell}>
        <div style={styles.logoContainer}>
          <img
            src={logo}
            alt={makeName || "logo"}
            style={styles.logoImage}
          />
        </div>
      </TableCell>

      <TableCell sx={styles.textStyle}>
        <span>{makeName} {generationName}</span>
      </TableCell>

      <TableCell sx={styles.textStyle}>
        {carOffers.title || "Nema naslova"}
      </TableCell>

      <TableCell sx={styles.textStyle}>
        {carOffers.description || "Nema opisa"}
      </TableCell>

      <TableCell sx={styles.defaultTextStyle}>
        <div>
          {stateLabel}
        </div>
      </TableCell>


    </TableRow>
  );
};

export default AllOffersTableRow;

const styles = {

  logoCell: {
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
    color: "black",
  },
  logoContainer: {
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  logoImage: {
    width: 48,
    height: 48,
    border: "1px solid rgba(203, 213, 225, 1)",
    borderRadius: 8,
    backgroundColor: "rgba(243, 244, 246, 1)",
    objectFit: "contain",
  },
  textStyle: {
    fontSize: "16px",
    color: "rgba(0,0,0,0.87)",
    fontWeight: 400,
    lineHeight: "24px",
  },
  defaultTextStyle: {
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
    color: "black",
  },
};
